import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberGoldenRedeemVoucher {
	private goldRdmForm:any   = $('#golden-redeem-voucher-form');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.goldRdmForm.find('input[type="email"]'));

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	initSelectizeInputs(): any {
		let _self = this;

		let voucherTypeInput = $('#golden-redeem--voucher-type');
		let getCountryOptions = $.Deferred();

		$.get('/content/dam/mas/json/voucherType.json')
		.done((data:any) => {
			let listItems = "<option value=''> </option>";

			for (let i = 0; i < data.voucheType.length; i++) {
				let firstIndex = data.voucheType[i].label.indexOf("-");
				let lastIndex = data.voucheType[i].label.lastIndexOf("-");
				listItems += "<option value=''>" + '' + "</option>";
				if ((firstIndex == lastIndex) && firstIndex > -1) {
					listItems += "<option value='" + data.voucheType[i].value + "'>" + data.voucheType[i].label + "</option>";
				}
			}
			getCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getCountryOptions.reject(error);
		});

		$.when(getCountryOptions).done(function(countryOptions:any) {
			voucherTypeInput.html(countryOptions);
			let inputSelectArr = $.makeArray(_self.goldRdmForm.find('select'));
			_self.memberBase.initSelectizeInputs(inputSelectArr);
			_self.formLogic();
			_self.validateForm();
		});
	}

	formLogic(): any {
		let _self = this;
		// voucher type value = miles number
		// multiplied by number of vouchers
		// total value displayed in new field
		let selectInput     = _self.goldRdmForm.find('#golden-redeem--voucher-type')[0].selectize;
		let totalInput      = _self.goldRdmForm.find('#golden-redeem--voucher-total');
		let incremeterInput = _self.goldRdmForm.find('#golden-redeem--voucher-to-use');
		let totMilesValue:any;
		let milesUnit = 0;
		let voucherUnit = 0;

		// filter statement table based on month value (first column)
		selectInput.on('change', function(val:any){
			let selectedVal:string = '0';
			selectedVal = val.split("|")[1];
    	// if(selectInput.$input.text().indexOf("-") > -1) {
    	// 	selectedVal = selectInput.$input.text().split("-")[1].trim().replace(",","");
    	// }
    	milesUnit = parseInt(selectedVal);

			if (!totalInput.hasClass('input-focused')) {
				totalInput.parent().addClass('input-focused');
				totalInput.parent().find('label').addClass('input-filled');
				totalInput.addClass('input-focused');
			}
			// update miles value used
			totMilesValue = voucherUnit * milesUnit;
			totalInput.val(totMilesValue);
		});

		// when incrementer value changes
		incremeterInput.on('incrementer.changed', function(e:any, val:any){
			if (!totalInput.hasClass('input-focused')) {
				totalInput.parent().addClass('input-focused');
				totalInput.parent().find('label').addClass('input-filled');
				totalInput.addClass('input-focused');
			}

			voucherUnit = parseInt(val);

			// update miles value used
			totMilesValue = voucherUnit * milesUnit;
			console.log(voucherUnit, milesUnit);
			totalInput.val(totMilesValue);
		});
	}

	/**
	 * [initIncrementer description]
	 * @return {any} [description]
	 */
	initIncrementer(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.goldRdmForm.find('.incrementer'));

		_self.memberBase.initIncrementer(inputElArr);
	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.goldRdmForm, function(validation: any) {
			// all your custom validation here

			// confirm email validation
			let emailId:string = 'golden-redeem--email';
			let confirmEmail:any = _self.goldRdmForm.find('#golden-redeem---confirm-email');
			confirmEmail.attr('data-parsley-equalto', '#'+emailId);

		});
	}
    
}
let scope:Element = document.querySelector('#golden-redeem-voucher-form');

if (scope) {
	try {
	let membergrv = new memberGoldenRedeemVoucher();
	membergrv.initTextInputs();
	membergrv.initSelectizeInputs();
	membergrv.initIncrementer();	
	} catch(e) {console.error(e);}
}
